<template>
  <div class="unlabelled-tab">
    <v-card>
      <v-card-text>
        <v-card>
          <v-card-text>
            <v-data-iterator :items="unlabelledList" :search="search">
              <template v-slot:header>
                <v-toolbar dark color="red accent-2" class="mb-1">
                  <v-text-field
                    v-model="search"
                    clearable
                    flat
                    solo-inverted
                    hide-details
                    color="red accent-2"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                  ></v-text-field>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col v-for="unlabelled in props.items" :key="unlabelled.uuid" cols="12">
                    <UnlabelledCard
                      :unlabelled="unlabelled"
                      :concepts="concepts"
                      :platforms="platforms"
                      :kitchens="kitchens"
                      :combos="combos"
                      :menuItems="menuItems"
                      :labelizationStatuses="labelizationStatuses"
                      v-on:selectItem="selectItem"
                      v-on:deleteUnlabelled="deleteUnlabelled"
                    />
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import UnlabelledCard from "@/components/Unlabelled/UnlabelledCard";
export default {
  components: { UnlabelledCard },
  props: {
    unlabelledList: { type: Array },
    concepts: { type: Array },
    kitchens: { type: Array },
    platforms: { type: Array },
    combos: { type: Array },
    menuItems: { type: Array },
    labelizationStatuses: { type: Object },
  },
  data: () => {
    return {
      search: "",
    };
  },
  methods: {
    selectItem(unlabelledUuid, itemUuid, itemType) {
      this.$emit("selectItem", unlabelledUuid, itemUuid, itemType);
    },
    deleteUnlabelled(unlabelledUuid) {
      this.$emit("deleteUnlabelled", unlabelledUuid);
    },
  },
};
</script>
